<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <h3>Support-Antwort</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newProviderForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-8 form-div">
                <h5>Anfrage</h5>
                <div class="mb-5" v-html="query.message"></div>
                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Message is required.',
                    }"
                  >
                    <div class="password-input-div">
                      <!-- <vue-editor
                        placeholder="Bitte schreiben Sie hier Ihre Antwort"
                        :class="errors[0] ? 'error-outline' : ''"
                        v-model="form.message"
                      ></vue-editor> -->
                      <ckeditor
                      v-model="form.message"
                      :config="editorConfig"
                      :error-messages="errors[0]"
                    ></ckeditor>
                    </div>
                  </ValidationProvider>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                  <!-- <br />
              <span class="form-errors" v-if="formError"
                >One or more fields has error. Please check form again.</span
              > -->
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="admin" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import VueTelInput from "vue-tel-input";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import { LOGIN, UPDATE_USER } from "@/core/services/store/auth.module";
import { VueEditor, Quill } from "vue2-editor";
import adminAPI from "@/api/admin";
import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);
Vue.use(Croppa, { componentName: "my-image-cropper" });

Vue.use(VueTelInput);
Vue.use(Notifications);
export default {
  name: "SupportResponse",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({
        name: "Login",
        query: {
          redirect: "support-response",
          to: this.$route.params.supportId,
        },
      });
    } else {
      this.getSupportQuery();
    }
  },
  data() {
    return {
      formError: false,
      userId: null,
      btnDisable: false,
      submitText: "Abschicken",
      query: [],
      form: {
        message: null,
      },
      editorConfig: {language: 'de',scayt_sLang : 'de_DE'},
    };
  },
  components: {
    // VueEditor,
  },
  methods: {
    getSupportQuery() {
      adminAPI
        .getSupportQuery(this.$route.params.supportId)
        .then((response) => {
          if (response.status == "success") {
            this.query = response.data;
          }
        });
    },
    goToBack() {
      this.$router.push({ name: "admin-dashboard" });
    },
    onSubmit() {
      this.$refs.newProviderForm.validate().then((success) => {
        if (success) {
          this.formError = false;
          this.btnDisable = true;
          this.submitText = "Wird abgeschickt...";
          let formData = new FormData();

          formData.append("user_id", this.currentUser.id);
          formData.append("support_id", this.$route.params.supportId);
          formData.append("message", this.form.message);
          setTimeout(() => {
            axios
              .request({
                method: "POST",
                url: "send-response",
                mimeType: "multipart/form-data",
                data: formData,
              })
              .then((response) => {
                if (response.data.status == "success") {
                  this.$notify({
                    group: "admin",
                    type: "success",
                    position: "bottom right",
                    text: response.data.msg,
                    duration: 5000,
                  });
                  this.btnDisable = false;
                  setTimeout(() => {
                    this.$router.push({ name: "admin-dashboard" });
                  }, 3000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Abschicken";
                  this.$notify({
                    group: "admin",
                    type: "error",
                    position: "bottom right",
                    text: response.data.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Abschicken";
                this.$notify({
                  group: "admin",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Abschicken";
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.croppa-container svg.icon-remove {
  top: 0 !important;
  right: unset !important;
  left: 0 !important;
}

.profile-initial-pic {
  position: relative;
}

.remove-btn {
  position: absolute;
  top: -5px;
  cursor: pointer;
}

.show-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.strendth-div {
  border: 1px solid lightgrey;
  height: 7px;
  margin: 2px;
  border-radius: 10px;
}

.red {
  background-color: red;
}

.orange {
  background-color: orange;
}

.green {
  background-color: green;
}
.password-input-div {
  position: relative;
}
.note-text {
  font-size: 12px;
  color: grey;
}
</style>
